<template>
    <div class="btn-group" ref="dropdownMenu" v-click-outside="hide">
        <slot name="button" v-bind="{title, type, show, toggle, buttonAttrs}">
            <oc-button-input
                v-bind="buttonAttrs"
                class="btn dropdown-toggle"
                v-class="['btn-' + $_type, buttonAttrs.class]"
                @click="toggle()"
                :text="title"
            />
        </slot>

        <div :class="classes">
            <slot :hide="hide">
                <template v-for="(action, index) in actions">
                    <div
                        v-if="action === '---'"
                        class="dropdown-divider"
                        @click="hide"
                    />
                    <oc-action
                        v-else
                        :key="index"
                        :row="row"
                        v-bind="action"
                        class="dropdown-item"
                        v-class="action.class"
                        @click="hide"
                    />
                </template>
            </slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'oc-dropdown',
    props: {
        actions: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: '...'
        },
        align: {
            type: String,
            default: 'left',
            validator: function (value) {
                return ['left', 'right'].indexOf(value) !== -1
            }
        },
        type: {
            type: String,
            default: 'default',
            validator: function (value) {
                return ['default', 'warning', 'error', 'success', 'info'].indexOf(value) !== -1
            }
        },
        buttonAttrs: {
            type: Object,
            default: () => ({})
        },
        row: {
            default: () => ({})
        }
    },
    data() {
        return {
            show: false
        }
    },
    computed: {
        $_type() {
            if( 'error' === this.type ) {
                return 'danger'
            }
            else if ( 'default' === this.type ) {
                return 'primary'
            }

            return this.type
        },
        classes() {
            return [
                'dropdown-menu',
                {
                    show: this.show,
                    'dropdown-menu-right': this.align === 'right'
                }
            ]
        }
    },
    methods: {
        toggle() {
            this.show = !this.show
        },
        hide() {
            this.show = false
        }
    }
}
</script>
